<template>
    <div class="card p-shadow-app">
        <div class="p-d-flex p-jc-between p-mb-3">
            <h3>Histórico de Logs</h3>
        </div>

        <TabView>
            <TabPanel header="Logs">
                <LogsDataTable />
            </TabPanel>
            <TabPanel header="Service Order Attempts">
                <LogServiceOrderAttemptsDataTable />
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import LogsDataTable from '@/components/logs/LogsDataTable.vue';
import LogServiceOrderAttemptsDataTable from '@/components/logs/LogServiceOrderAttemptsDataTable.vue';

export default {
    name: 'LogsView',
    components: {
        TabView,
        TabPanel,
        LogsDataTable,
        LogServiceOrderAttemptsDataTable,
    },
}
</script>

<style scoped>
</style>